import React from "react";
import ImageWithPlaceholder from "../Common/ImageWithPlaceholder";

import ParticipantControls from "./ParticipantControls";

export default function Participant({ participant, teamId }) {
    return (
        <div className="user ms-3">
            <a
                href={"/user/index/" + participant.id}
                rel="tooltip"
                title="Go to profile"
                className="user-img"
            >
                <ImageWithPlaceholder src={"/" + participant.imagePath} alt="" />
            </a>
            <div className="user-info">
                <p className="user-name">
                    {participant.firstName + " " + participant.lastName}
                    <br />
                    <span className="user-email">{participant.email}</span>
                </p>

                <ParticipantControls
                    participantId={participant.id}
                    teamId={teamId}
                />
            </div>
        </div>
    );
}
